import React, { useState } from "react";
import { NavLink } from "react-router-dom";

const Header = () => {
  const [isHeaderOpen, setIsHeaderOpen] = useState(false);

  return (
    <div>
      <nav className="bg-white shadow-lg border-b border-gray-100 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <div className="flex-shrink-0">
              <NavLink to="/" className="flex items-center">
                <img
                  className="h-12 w-auto"
                  src="logo.png"
                  alt="Alpha Appliances"
                />
              </NavLink>
            </div>

            {/* Desktop Navigation */}
            <div className="hidden md:block">
              <div className="flex items-center space-x-8">
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "text-indigo-600 font-semibold px-3 py-2 rounded-lg text-base transition-colors duration-200"
                      : "text-gray-600 hover:text-indigo-600 font-medium px-3 py-2 rounded-lg text-base transition-colors duration-200"
                  }
                  to={"/"}
                >
                  Home
                </NavLink>
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "text-indigo-600 font-semibold px-3 py-2 rounded-lg text-base transition-colors duration-200"
                      : "text-gray-600 hover:text-indigo-600 font-medium px-3 py-2 rounded-lg text-base transition-colors duration-200"
                  }
                  to={"about-us"}
                >
                  About Us
                </NavLink>
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "text-indigo-600 font-semibold px-3 py-2 rounded-lg text-base transition-colors duration-200"
                      : "text-gray-600 hover:text-indigo-600 font-medium px-3 py-2 rounded-lg text-base transition-colors duration-200"
                  }
                  to={"/products"}
                >
                  Products
                </NavLink>
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "text-indigo-600 font-semibold px-3 py-2 rounded-lg text-base transition-colors duration-200"
                      : "text-gray-600 hover:text-indigo-600 font-medium px-3 py-2 rounded-lg text-base transition-colors duration-200"
                  }
                  to={"/partnership"}
                >
                  Partnership
                </NavLink>
                <NavLink
                  className={({ isActive }) =>
                    isActive
                      ? "text-indigo-600 font-semibold px-3 py-2 rounded-lg text-base transition-colors duration-200"
                      : "text-gray-600 hover:text-indigo-600 font-medium px-3 py-2 rounded-lg text-base transition-colors duration-200"
                  }
                  to={"/contact-us"}
                >
                  Contact
                </NavLink>
              </div>
            </div>

            {/* Contact Icons - Desktop */}
            <div className="hidden md:flex items-center space-x-4">
              <a
                className="flex items-center justify-center w-10 h-10 bg-indigo-100 rounded-full hover:bg-indigo-200 transition-colors duration-200"
                href="mailto:info@alphaappliances.in"
                title="Email us"
              >
                <svg
                  className="w-5 h-5 text-indigo-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                  />
                </svg>
              </a>
              <a
                className="flex items-center justify-center w-10 h-10 bg-orange-100 rounded-full hover:bg-orange-200 transition-colors duration-200"
                href="tel:+919558886009"
                title="Call us"
              >
                <svg
                  className="w-5 h-5 text-orange-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                  />
                </svg>
              </a>
            </div>

            {/* Mobile menu button */}
            <div className="md:hidden">
              <button
                className="flex items-center justify-center w-10 h-10 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors duration-200"
                onClick={() => setIsHeaderOpen(!isHeaderOpen)}
              >
                <svg
                  className="w-6 h-6 text-gray-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  {isHeaderOpen ? (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M6 18L18 6M6 6l12 12"
                    />
                  ) : (
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M4 6h16M4 12h16M4 18h16"
                    />
                  )}
                </svg>
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isHeaderOpen && (
          <div className="md:hidden bg-white border-t border-gray-100 shadow-lg">
            <div className="px-4 pt-2 pb-6 space-y-2">
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "text-indigo-600 font-semibold block px-4 py-3 rounded-lg text-base transition-colors duration-200"
                    : "text-gray-600 hover:text-indigo-600 font-medium block px-4 py-3 rounded-lg text-base transition-colors duration-200"
                }
                to={"/"}
                onClick={() => setIsHeaderOpen(false)}
              >
                Home
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "text-indigo-600 font-semibold block px-4 py-3 rounded-lg text-base transition-colors duration-200"
                    : "text-gray-600 hover:text-indigo-600 font-medium block px-4 py-3 rounded-lg text-base transition-colors duration-200"
                }
                to={"about-us"}
                onClick={() => setIsHeaderOpen(false)}
              >
                About Us
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "text-indigo-600 font-semibold block px-4 py-3 rounded-lg text-base transition-colors duration-200"
                    : "text-gray-600 hover:text-indigo-600 font-medium block px-4 py-3 rounded-lg text-base transition-colors duration-200"
                }
                to={"/products"}
                onClick={() => setIsHeaderOpen(false)}
              >
                Products
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "text-indigo-600 font-semibold block px-4 py-3 rounded-lg text-base transition-colors duration-200"
                    : "text-gray-600 hover:text-indigo-600 font-medium block px-4 py-3 rounded-lg text-base transition-colors duration-200"
                }
                to={"/partnership"}
                onClick={() => setIsHeaderOpen(false)}
              >
                Partnership
              </NavLink>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "text-indigo-600 font-semibold block px-4 py-3 rounded-lg text-base transition-colors duration-200"
                    : "text-gray-600 hover:text-indigo-600 font-medium block px-4 py-3 rounded-lg text-base transition-colors duration-200"
                }
                to={"/contact-us"}
                onClick={() => setIsHeaderOpen(false)}
              >
                Contact
              </NavLink>

              {/* Mobile Contact Icons */}
              <div className="flex items-center justify-center space-x-4 pt-4 border-t border-gray-100">
                <a
                  className="flex items-center justify-center w-12 h-12 bg-indigo-100 rounded-full hover:bg-indigo-200 transition-colors duration-200"
                  href="mailto:info@alphaappliances.in"
                  title="Email us"
                >
                  <svg
                    className="w-6 h-6 text-indigo-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </a>
                <a
                  className="flex items-center justify-center w-12 h-12 bg-orange-100 rounded-full hover:bg-orange-200 transition-colors duration-200"
                  href="tel:+919558886009"
                  title="Call us"
                >
                  <svg
                    className="w-6 h-6 text-orange-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        )}
      </nav>
    </div>
  );
};

export default Header;
